namespace TabAurous.Sales {
    export interface ApprovalOutRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        AutoPosting?: boolean;
        PartyId?: number;
        LedgerName?: string;
        PartyCode?: string;
        GstVat?: string;
        Pan?: string;
        Address1?: string;
        Country?: string;
        State?: string;
        City?: string;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        BillAddId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        ItemDetails?: ApprovalOutItemsRow[];
        DepartmentId?: number;
        RefVoucherId?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        ProductItemImage?: string;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        RoundOff?: number;
        PostingDate?: string;
        IsPosted?: boolean;
        Username?: string;
        MF?: number;
    }

    export namespace ApprovalOutRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Sales.ApprovalOut';
        export const deletePermission = 'Sales:Approval:Delete';
        export const insertPermission = 'Sales:Approval:Add';
        export const readPermission = '*';
        export const updatePermission = 'Sales:Approval:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            AutoPosting = "AutoPosting",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            PartyCode = "PartyCode",
            GstVat = "GstVat",
            Pan = "Pan",
            Address1 = "Address1",
            Country = "Country",
            State = "State",
            City = "City",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            BillAddId = "BillAddId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            DepartmentId = "DepartmentId",
            RefVoucherId = "RefVoucherId",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            ProductItemImage = "ProductItemImage",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            RoundOff = "RoundOff",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            Username = "Username",
            MF = "MF"
        }
    }
}
